<template>
  <div
    ref="badge"
    class="ak-badge"
    data-testid="badge-count-articles"
  >
    {{ formatCountArticles }}
  </div>
</template>

<script lang="ts">
import { productsCount } from '@monolith/legacy/modules/cart-2/composables/use-counters';
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'BadgeCountArticles',
  setup() {

    const formatCountArticles = computed(() => {
      return parseInt(productsCount.value, 10) <= 9999
        ? parseInt(productsCount.value, 10)
        : '9999+';
    });

    return {
      formatCountArticles,
    };
  },
  watch: {
    formatCountArticles() {
      if (!this.$refs.badge) {
        return;
      }
      (this.$refs.badge as HTMLElement).classList.add('pulse');

      setTimeout(() => {
        if (!this.$refs.badge) {
          return;
        }
        (this.$refs.badge as HTMLElement).classList.remove('pulse');
      }, 500);
    },
  },
});
</script>

<style scoped>
select {
  width: 100%;
}
button {
  width: 100%;
  margin-top: 10px;
}
</style>

<style scoped lang="scss">
@import '@css/vue-import';
$zoom: 1.3;

@keyframes pulse {
  from {
    transform: scale(1, 1);
  }

  50% {
    transform: scale($zoom, $zoom);
  }

  to {
    transform: scale(1, 1);
  }
}

.pulse {
  animation-name: pulse;
  animation-duration: 500ms;
}

.ak-badge {
  @apply ds-text-white ds-text-sm ds-font-semibold ds-pt-0.5;
}
</style>
